var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49919 15.8391C1.31332 15.8391 1.15843 15.7772 1.00354 15.6533C0.724732 15.3745 0.724732 14.9408 1.00354 14.662L7.50897 8.00163L1.00354 1.37228C0.724732 1.09348 0.724732 0.659783 1.00354 0.380978C1.28234 0.102174 1.71604 0.102174 1.99484 0.380978L8.99593 7.50598C9.27473 7.78478 9.27473 8.21848 8.99593 8.49728L1.99484 15.6223C1.87093 15.7462 1.68506 15.8391 1.49919 15.8391Z",
    fill: "#111928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.c345ed36be36f0711b6b0c5bdc49f43d.svg";
export { ForwardRef as ReactComponent };